import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'

import * as MapSelectors from '../../Mars/Map/map.selectors'
// import * as PhaseSelectors from "../../Mars/Phases/phases.selectors"
import * as tutorialActions from '../tutorial.actions'

import * as tutorialSelectors from '../tutorial.selectors'

import BuildingListInfo from '../../Mars/Map/MapScreen/TilePopup/TileInfo/BuildingListInfo'

const mapStateToProps = (state) => ({
  selectedTile: MapSelectors.getSelectedTile(state),
  parameters: MapSelectors.getBuildingParameters(state),

  visitorInfo: tutorialSelectors.getVisitorInfo(state),
  visitorMap: tutorialSelectors.getVisitorMap(state),
  attacking: MapSelectors.getAttackState(state),

  currentPhase: tutorialSelectors.getCurrentPhase(state),
  buildings: MapSelectors.getBuildings(state),
  userMap: tutorialSelectors.getUserMap(state),
  userData: tutorialSelectors.getIndicatorsAsUserData(state),
  isTutorial: true,
})

const mapDispatchToProps = (dispatch) => ({
  removePopup: bindActionCreators(tutorialActions.removePopup, dispatch),
  createBuilding: bindActionCreators(tutorialActions.createBuilding, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(BuildingListInfo))
